export var ApolloSettingKey;
(function (ApolloSettingKey) {
    ApolloSettingKey["UserLanguage"] = "UserLanguage.Language";
    ApolloSettingKey["UserLanguageDate"] = "UserLanguage.Date";
    ApolloSettingKey["UserTheme"] = "UserTheme.Theme";
    ApolloSettingKey["UserAccessibility"] = "UserAccessibility.Accessibility";
    ApolloSettingKey["UserAlert"] = "UserAlert.AlertDuration";
    ApolloSettingKey["Favorites"] = "Favorites";
})(ApolloSettingKey || (ApolloSettingKey = {}));
